import './About.css';

export default function About() {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="section-label">
          <span className="label-line" />
          <span>About Me</span>
        </div>

        <div className="about-grid">
          <div className="about-left">
            <div className="about-avatar">
              <div className="avatar-ring" />
              <div className="avatar-inner">
                <span>S</span>
              </div>
              <div className="avatar-tag">
                <span>📍</span> Lalitpur, Nepal
              </div>
            </div>
          </div>

          <div className="about-right">
            <h2 className="section-title">
              Crafting digital experiences that <em>actually</em> matter
            </h2>
            <p className="about-text">
              I'm a frontend developer with 1+ year of professional experience building clean,
              responsive, and user-centered web interfaces. Currently at <strong>Inspiring Lab</strong>,
              where I develop scalable UIs, integrate APIs, and collaborate closely with backend
              and design teams.
            </p>
            <p className="about-text">
              My journey started with a BIM degree from Nagarjuna College of IT, and has grown
              through real-world projects — from AI-powered dashboards to e-commerce platforms.
              I care deeply about writing maintainable code and creating seamless user experiences.
            </p>

            <div className="about-cards">
              <div className="about-card">
                <span className="card-icon">🎓</span>
                <div>
                  <div className="card-title">BIM Graduate</div>
                  <div className="card-sub">Nagarjuna College of IT · 2023</div>
                </div>
              </div>
              <div className="about-card">
                <span className="card-icon">💼</span>
                <div>
                  <div className="card-title">Junior Frontend Dev</div>
                  <div className="card-sub">Inspiring Lab · Present</div>
                </div>
              </div>
              <div className="about-card">
                <span className="card-icon">⚡</span>
                <div>
                  <div className="card-title">Currently Learning</div>
                  <div className="card-sub">Advanced React Patterns & TypeScript</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
